import { render } from "./RuletaAdmin.vue?vue&type=template&id=02bca908&scoped=true"
import script from "./RuletaAdmin.vue?vue&type=script&lang=js"
export * from "./RuletaAdmin.vue?vue&type=script&lang=js"

import "./RuletaAdmin.vue?vue&type=style&index=0&id=02bca908&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02bca908"]])

export default __exports__